import { create } from "zustand";

type ToasterPosition =
  | "top-left"
  | "top-center"
  | "top-right"
  | "bottom-left"
  | "bottom-center"
  | "bottom-right";

interface ToasterState {
  position: ToasterPosition;
  setPosition: (position: ToasterPosition) => void;
}

export const useToasterStore = create<ToasterState>((set) => ({
  position: "top-center",
  setPosition: (position) => set({ position }),
}));
